import React from 'react'
import {stepStyle} from './style'
import {
    Table,

} from '@devexpress/dx-react-grid-material-ui';

const TableCell = ({row, ...restProps}) => {
    if (row.type == 'step-total' || ({...restProps}.column.total) === true) {
        return <Table.Cell style={{color: "#000", fontWeight: "bold"}} {...restProps} />;
    } else if (({...restProps}.column.editable) === false && (row.type == 'row' || row.type == 'step-row')) {
        return <Table.Cell style={{color: "#8f8f8f"}} {...restProps} />;
    }
    return <Table.Cell {...restProps} />;

}

export default TableCell
